/**
 * The word count a Writing candidate is watching.
 *
 * Counted the way IELTS counts: whitespace separates words, so a hyphenated
 * compound is one word, a number is one word, and punctuation attached to a
 * word does not make another. It runs on every keystroke because that is what
 * the count is for — a candidate pacing 250 words needs to see it move, not
 * find out afterwards that they were short and lost marks for it.
 */
export function countWords(text: string): number {
  const trimmed = text.trim();
  if (!trimmed) return 0;
  return trimmed.split(/\s+/).filter((word) => /[\p{L}\p{N}]/u.test(word)).length;
}
